import PokemonList from "../../components/PokemonList/PokemonList";

const HomePage = (): JSX.Element => {
  return <PokemonList isFavourite={false} />;
};

export default HomePage;
